import axios from 'axios';
import _ from 'lodash';

import cookie from 'react-cookies';

export const FETCH_USER_TOKEN = 'fetch_user_token';

export const FETCH_ALL_CATEGORIES = 'fetch_all_catagories';
export const FETCH_SINGLE_CATEGORY = 'fetch_single_category';
export const FETCH_SINGLE_FLOWER = 'fetch_single_flower';
export const SORT_FLOWER = 'sort_flower';

export const FETCH_SHOPPINGCART_ITEMS = 'fetch_shoppingcart_items';
export const ADD_SHOPPINGCART_ITEM = 'add_shoppingcart_item';
export const UPDATE_SHOPPINGCART_ITEM = 'update_shoppingcart_items';
export const DELETE_SHOPPINGCART_ITEM = 'delete_shoppingcart_items';

export const FETCH_REGION = 'fetch_region';
export const FETCH_PLACE = 'fetch_place';
export const FETCH_PRICE_START = 'fetch_price_start';
export const FETCH_PRICE_END = 'fetch_price_end';
export const DELETE_SHOPPING_CART = 'delete_shopping_cart';
export const SUBSCRIBE = 'subscribe';
// export const ROOT_URL = "//nodejs-uat-432592793.ap-southeast-1.elb.amazonaws.com";
export const ROOT_URL = '//api.bnm.hk';
// export const ROOT_URL = "http://localhost:1337";


// const ROOT_URL = " ";

export function fetchUserToken() {
    const userToken = cookie.load('userToken');
    const request = axios.get(`${ROOT_URL}/visitor/start?token=${userToken}`);
    return {
      type: FETCH_USER_TOKEN,
      payload: request,
    };
}

export function fetchAllCatagories() {
  const request = axios.get(`${ROOT_URL}/category?_sort=createdAt&_order=DESC`);

  return {
    type: FETCH_ALL_CATEGORIES,
    payload: request,
  };
}
export function getSubCategoryFlowers(categoryName, subCategoryName) {
  return axios.get(`${ROOT_URL}/subcategory/flowers?category=${categoryName}&subcategory=${subCategoryName}`);
}
export function containsSubCategory(categoryName) {
  return axios.get(`${ROOT_URL}/category/subcategory?category=${categoryName}`);
}
export function fetchSingleCatagory(categoryName) {
  const request = axios.get(`${ROOT_URL}/flower/category?category=${categoryName}`);
  return {
    type: FETCH_SINGLE_CATEGORY,
    payload: request,
  };
}

export function fetchSingleFlower(inputFlowerName) {
  const request = axios.get(`${ROOT_URL}/flower/search?keyword=${inputFlowerName}`);

  return {
    type: FETCH_SINGLE_FLOWER,
    payload: request,
  };
}

export function sortFlower(sortByValue, category, subcategory) {
  const request = axios.get(`${ROOT_URL}/flower/sort?sortBy=${sortByValue}&category=${category}${subcategory ? `&subcategory=${subcategory}` : ''}`);

  return {
    type: SORT_FLOWER,
    payload: request,
  };
}

export function fetchShoppingCartItems(userToken) {
    const request = axios.get(`${ROOT_URL}/visitor/shoppingCartShow?token=${userToken}`);
    return {
      type: FETCH_SHOPPINGCART_ITEMS,
      payload: request,
    };
}

export function addShoppingCartItem(token, flowerId, color, number, callback = null) {
    const requestBody = {
      token,
      flowerId,
      color: { [color]: number },
    };
    const request = axios.post(`${ROOT_URL}/visitor/shoppingCartAdd`, requestBody).then((result) => {
      alert(result.data);
    });

    return {
      type: ADD_SHOPPINGCART_ITEM,
      payload: request,
    };
}

export function updateShoppingCartItem(token, flowerId, previousColor, previousNumber, newColor, newNumber) {
    const requestBody = {
      token,
    	flowerId,
    	color: {
        [previousColor]: previousNumber,
      },
    	newColor: {
        [newColor]: newNumber,
      },
    };
    const request = axios.post(`${ROOT_URL}/visitor/shoppingCartUpdate`, requestBody);

    return {
      type: UPDATE_SHOPPINGCART_ITEM,
      payload: request,
    };
}

export function deleteShoppingCartItem(token, flowerId, previousColor, previousNumber) {
    const requestBody = {
      token,
    	flowerId,
    	color: {
        [previousColor]: previousNumber,
      },
    };
    const request = axios.delete(`${ROOT_URL}/visitor/shoppingCartDrop`, { data: requestBody });

    return {
      type: DELETE_SHOPPINGCART_ITEM,
      payload: request,
    };
}

export function fetchRegion() {
  const request = axios.get(`${ROOT_URL}/region/regionList`);

  return {
    type: FETCH_REGION,
    payload: request,
  };
}

export function fetchPlace() {
  const request = axios.get(`${ROOT_URL}/region/placeList`);

  return {
    type: FETCH_PLACE,
    payload: request,
  };
}

export function sendEmailRequest(token, shoppingCartItem, orderListContactDetail) {
    const itemList = [];
    _.map(shoppingCartItem, (item) => {
      const itemObj = {};
      console.log(item);
      itemObj.name = item.product.name;
      // itemObj.colorNumber = {red:""};
      //   itemObj.colorNumber = { 'color as shown': 1 };
      itemObj.flowerId = item.product.id;
      itemObj.quantity = item.order['#F17013'];
      itemList.push(itemObj);
    });

    const recipientList = [];
    const getTodayDate = () => {
        let today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        const yyyy = today.getFullYear();

        today = `${yyyy}-${mm}-${dd}`;


        return today;
    };

    if (!orderListContactDetail.recipient1DisplayName) {
      // only one recipient
        console.log('Contact detail');
      console.log(orderListContactDetail);

      const recipientObj = {
          gender: orderListContactDetail.recipienttitle === undefined ? 'Mr.' : orderListContactDetail.recipienttitle,
          firstName: orderListContactDetail.recipientfirstName,
          lastName: orderListContactDetail.recipientlastName,
          displayName: orderListContactDetail.recipientDisplayName,
          telephone: orderListContactDetail.recipientPhone,
          company: orderListContactDetail.recipientCompany === undefined ? getTodayDate() : orderListContactDetail.deliveryDate,
          deliveryDate: orderListContactDetail.deliveryDate,
          deliveryTime: orderListContactDetail.deliveryTime,
          deliveryAddress: orderListContactDetail.deliveryAddress,
          region: orderListContactDetail.subRegionValue,
          to: orderListContactDetail.messageTo,
          from: orderListContactDetail.messageFrom,
          message: orderListContactDetail.messageContent,
          hideSenderName: orderListContactDetail.hideSenderName === undefined ? 'false' : orderListContactDetail.hideSenderName.toString(),
          remarks: orderListContactDetail.orderNotes,
      };
      recipientList.push(recipientObj);
    } else {
      _.map(shoppingCartItem, (item, index) => {
        // many reciepients

        const recipientObj = {};
        recipientObj.gender = orderListContactDetail[`recipient${index + 1}title`] === undefined ? 'Mr.' : orderListContactDetail[`recipient${index + 1}title`];
        recipientObj.firstName = orderListContactDetail[`recipient${index + 1}firstName`];
        recipientObj.lastName = orderListContactDetail[`recipient${index + 1}lastName`];
          recipientObj.displayName = orderListContactDetail[`recipient${index + 1}DisplayName`];
          recipientObj.telephone = orderListContactDetail[`recipientPhone${index + 1}`];
        recipientObj.company = orderListContactDetail[`recipientCompany${index + 1}`];
        recipientObj.deliveryDate = orderListContactDetail[`deliveryDate${index + 1}`] === undefined ? getTodayDate() : orderListContactDetail[`deliveryDate${index + 1}`];
        recipientObj.deliveryTime = orderListContactDetail[`deliveryTime${index + 1}`];
        recipientObj.deliveryAddress = orderListContactDetail[`deliveryAddress${index + 1}`];
        recipientObj.region = orderListContactDetail[`subRegionValue${index + 1}`];
        recipientObj.message = orderListContactDetail[`messageContent${index + 1}`];
        recipientObj.hideSenderName = orderListContactDetail[`hideSenderName${index + 1}`] === undefined ? 'false' : orderListContactDetail[`hideSenderName${index + 1}`].toString();
        recipientObj.remarks = orderListContactDetail[`orderNotes${index + 1}`];
        recipientObj.to = orderListContactDetail[`messageTo${index + 1}`];
        recipientObj.from = orderListContactDetail[`messageFrom${index + 1}`];
        recipientList.push(recipientObj);
      });
    }
    // }

    // let testCardNumber = "";
    Object.keys(orderListContactDetail).forEach((key) => {
      if (key === '') {
        if (orderListContactDetail[key] !== null) {
          // testCardNumber = Array(5).join(orderListContactDetail[key]);
        }
      }
    });

   /* let gender = "Mr."
    if(orderListContactDetail.gender !== undefined){
      gender = orderListContactDetail.gender
   } */

    const requestBody = {


        sender: {
            gender: orderListContactDetail.contacttitle === undefined ? 'Mr.' : orderListContactDetail.contacttitle,

            // firstName: orderListContactDetail.contactfirstName,
            // lastName: orderListContactDetail.contactlastName,
            displayName: orderListContactDetail.contactDisplayName,
            email: orderListContactDetail.contactPersonEmailAddress,
            telephone: orderListContactDetail.contactPersonPhone,
            token,
            officialReceipt: orderListContactDetail.isReceipt === undefined ? 'false' : orderListContactDetail.isReceipt.toString(),
            sendCopy: orderListContactDetail.isCopy === undefined ? false : orderListContactDetail.isCopy,
            paymentMethod: orderListContactDetail.paymentMethod === undefined ? 'None' : orderListContactDetail.paymentMethod,
            cardHolderName: orderListContactDetail.cardholderName === undefined ? 'No Name' : orderListContactDetail.cardholderName,
            cardNumber: orderListContactDetail.cardNumber === undefined ? '4242424242424242' : orderListContactDetail.cardNumber,
            ccExpiryDate: orderListContactDetail.expiry,
        },
        item: itemList,
        recipient: recipientList,
    };

    // console.log('requestBody', requestBody);
    axios.post(`${ROOT_URL}/email/confirm`, requestBody, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then((response) => {
      clearShoppingCartItem();
    })
    .catch((error) => {
      console.error(error);
    });
}
export async function fetchRegionPrice(regionName) {
  const request = await axios.get(`${ROOT_URL}/region/getprice/${regionName}`);
  return {
    type: FETCH_PRICE_END,
    payload: request.data,
  };
}
export async function removeShoppingCartItems(token) {
  const requestBody = {
    token,
  };
  console.log('removeShoppingCartItems', token);
  const request = await axios.delete(`${ROOT_URL}/visitor/emptyShoppingCart/`, { data: requestBody });
  console.log('DELETE_SHOPPING_CART', token);
  return {
    type: DELETE_SHOPPING_CART,
    payload: request.data,
  };
}
export function clearShoppingCartItem() {
  return {
    type: DELETE_SHOPPING_CART,
  };
}
export async function subscribe(email) {
  const requestBody = {
    email,
  };
  const request = await axios.post(`${ROOT_URL}/visitor/subscribe/`, { data: requestBody });
  return {
    type: SUBSCRIBE,
    payload: request.data,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/index.js